import * as StateLib from "@/Utils/StateLib";
import { Menu } from "@theorgchartdev/storybook";
import React from "react";
import { useRouteState } from "@/hooks/useRouteState";
import { appstr } from "@coreapp/utils/appstr";

const ZoomCanvasMenu = props => {
  const { setParam: setRouteParam } = useRouteState();
  let wsMgr = StateLib.GetWSMgr();
  let curZoom = 100;
  if (wsMgr && wsMgr.fCanvasPanel) {
    curZoom = Math.floor(wsMgr.fCanvasPanel.GetScaleFactor() * 100);
  }
  // URL-driven: write ?zoom=N. useZoomSync hook reads the URL and
  // drives wsMgr.Zoom + DoOptimizePages + ReRenderCanvas in coreapp,
  // so zoom changes are bookmarkable / shareable / refreshable.
  const UpdateZoom = target => setRouteParam("zoom", String(target.value));

  const BuildZoomOptions = () => {
    let zoomOptions = [];
    for (let i = 25; i <= 150; i += 25) {
      let zoomOption = {};
      zoomOption.label = i.toString() + "%";
      zoomOption.value = i;
      zoomOption.clickHandler = UpdateZoom;
      zoomOption.dataTestId = `chart-mode-toolbar-zoom-${i}`;
      zoomOptions.push(zoomOption);
    }
    return zoomOptions;
  };

  return (
    <Menu
      buttonSize={"small"}
      dataTestId={"zoom-menu"}
      label={curZoom + "%"}
      value={curZoom}
      position={"bottom"}
      triggerProps={{
        tooltipProps: { message: appstr("Zoom") }
      }}
      options={BuildZoomOptions()}
    />
  );
};

export default ZoomCanvasMenu;
